<template>
  <div class="page" :class="[isAdmin ? 'admin':'teacher', className]">
    <div class="right-content">
      <keep-alive>
        <router-view v-if="$route.meta.keepAlive && !noPermission" />
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive && !noPermission" />
    </div>
    <!-- 用户权限 -->
    <TipModal
      :loginButton="false"
      :maskClosable="false"
      :visible="noPermission"
      @ok="noPermission = false"
      :className="['noOk', 'nocancel']"
      @cancel="noPermission = false"
      :desc="`
        <img class='noPermission' src='` + require('@/assets/img/nr.png') + `'/>`" />
  </div>
</template>

<script>
import cookie from 'js-cookie'
import MenuBar from '@/components/menuBar/index.vue'
import Header from '@/components/GlobalHeader/AvatarDropdown.vue'
import TipModal from '@/components/tipModal/index.vue'
import { mapState } from 'vuex'
import { registerMicroApps, start } from 'qiankun'

export default {
  name: 'BlankLayout',
  components: {
    Header,
    MenuBar,
    TipModal
  },
  data() {
    return {
      className: 'full',
      noPermission: false,
      user: cookie.getJSON('user_infor'),
      menuData: [],
      isAdmin: false
    }
  },
  computed: {
    ...mapState({
      collapsed: state => state.app.collapsed
    })
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.className = (!vm.isAdmin) && to.name !== 'index' ? 'full' : undefined
    })
  },
  watch: {
    '$route': {
      handler(el) {
        this.user = cookie.getJSON('user_infor')
        this.isAdmin = this.$route.meta.permission.includes('admin')
        this.className = (!this.isAdmin) && el.name !== 'index' ? 'full' : undefined
      }
    }
  },
  methods: {
    changePermission(type) {
      console.log(' ----->', cookie.getJSON('user_type'), type)
      this.noPermission = type
    },
    changeMenuData(data) {
      this.menuData = data
    }
  },
  mounted() {
    this.isAdmin = this.$route.meta.permission.includes('admin')
    const entryMap = {
      development: '//localhost:9522',
      qa: '//examine.ptsub.qa.growlib.com',
      production: '//examine.ptsub.growlib.com'
    }
    const apps = [
      {
        name: 't-examine',
        entry: entryMap[process.env.NODE_ENV], // 默认会加载这个html 解析里面的js 动态的执行 （子应用必须支持跨域）fetch
        container: '#t-examine',
        activeRule: '/t-examine'
      }
    ]
    registerMicroApps(apps) // 注册应用
    start({
        prefetch: false, // 取消预加载
        sandbox: {
          // experimentalStyleIsolation: true
        }
      })// 开启
  }
}
</script>

<style lang="less" scoped>
.page{
  height: 100vh;
  display: flex;
  background: url('./../assets/img/bj_d.png');
  background-size: 100% 100%;
  background-position: center;
  .menubar{
    width: 230px;
    height: 100%;
    // overflow-x: hidden;
    transition: width 0.3s ease-out;
    position: relative;
    // background: rgba(225, 225, 225, 0.7);
    // box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.07);
  }
  .right-content{
    height: 100%;
    // padding: 20px 20px 0 12px;
    width: 100% !important;
    >div{
      height: calc(100% - 55px);
      // padding: 46px 28px 46px 19px;
      // background: url('./../assets/img/bj_6.png');
      background-size: 100% 100%;
      background-position: center;
    }
    >div:nth-child(2) {
      overflow: auto;
    }
    .header-tool{
      display: flex;
      align-items: center;
      height: auto !important;
      justify-content: flex-end;
      background: none !important;
    }
  }
}
.teacher.page.full {
  .header-tool{
      padding-right: 20px;
    }
}
.teacher.page {
  .menu-collapsed {
    width: 98px;
  }
  .menu-collapsed + * {
    width: calc(100% - 98px) !important;
  }
}
.admin.page{
  .menu-collapsed {
    width: 80px;
  }
  .menu-collapsed + * {
    width: calc(100% - 80px) !important;
  }
  background: #F7F7F7;
  .right-content{
    height: calc(100% - 26px);
    padding: 0;
    >div{
      background: #fff;
      padding: 0 27px 22px;
      height: calc(100% - 50px);
      background-size: 100% 100%;
      background-position: center;
      border-top-right-radius: 20px;
      overflow: auto;
    }
    .header-tool{
      // background: #fff !important;
      padding: 20px 20px 0 !important;
    }
    .container {
      padding-top: 20px;
    }
  }
}
.teacher.page.full{
  .right-content{
    padding-right: 0;
    height: calc(100% - 47px);
    >div{
      height: 100%;
    }
  }
}
.right-content > div:nth-child(3){
  display: none;
}
@media screen and(min-width: 1700px) and (max-width: 1900px){
  .page{
    .menubar{
      width: 210px;
      .admin-menu {
        color: red;
      }
      .logo {
        color: red;
        img {
          width: 120px;
        }
      }
    }
    .right-content{
      width: calc(100% - 210px);
    }
  }
}
@media screen and(min-width: 1500px) and (max-width: 1700px){
  .page{
    .menubar{
      width: 170px;
    }
    .right-content{
      width: calc(100% - 170px);
    }
  }
}
@media screen and(min-width: 1300px) and (max-width: 1500px){
  .page{
    .menubar{
      width: 170px;
    }
    .right-content{
      width: calc(100% - 170px);
    }
  }
}
@media screen and (min-width: 1200px) and (max-width: 1300px){
  .page{
    .menubar{
      width: 153px;
    }
    .right-content{
      width: calc(100% - 153px);
    }
  }
}
@media screen and (max-width: 1200px){
  .page{
    .menubar{
      width: 130px;
    }
    .right-content{
      width: calc(100% - 130px);
    }
  }
}
</style>
<style>
#t-examine > div{
  height: 100%;
}
</style>
